/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SendInsightShareEmailInput = {|
  insightShareId?: ?string,
  emails: string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type sendInsightShareEmailMutationVariables = {|
  input: SendInsightShareEmailInput
|};
export type sendInsightShareEmailMutationResponse = {|
  +sendInsightShareEmail: ?{|
    +viewer: ?{|
      +id: string
    |}
  |}
|};
export type sendInsightShareEmailMutation = {|
  variables: sendInsightShareEmailMutationVariables,
  response: sendInsightShareEmailMutationResponse,
|};
*/


/*
mutation sendInsightShareEmailMutation(
  $input: SendInsightShareEmailInput!
) {
  sendInsightShareEmail(input: $input) {
    viewer {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SendInsightShareEmailInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendInsightShareEmailPayload",
    "kind": "LinkedField",
    "name": "sendInsightShareEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendInsightShareEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendInsightShareEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "sendInsightShareEmailMutation",
    "operationKind": "mutation",
    "text": "mutation sendInsightShareEmailMutation(\n  $input: SendInsightShareEmailInput!\n) {\n  sendInsightShareEmail(input: $input) {\n    viewer {\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '81fbc49baf50bab486fb23f8db97c57e';

module.exports = node;
